// language=GraphQL
export const ALL_CAPACITY_SETTINGS_QUERY = `query Query($withAgeGroupCapacities: Boolean = false, $withAgeGroupCapacitiesAgeGroup: Boolean = false, $withAgeGroupedTotalCapacities: Boolean = false, $withAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withPartialOccupancyAllowedAgeGroups: Boolean = false) {
  capacitySettings: allAccommodationCapacitySettings {
    id
    totalCapacity
    rangesAllowed
    ageGroupCapacities @include(if: $withAgeGroupCapacities) {
      id
      ageGroup @include(if: $withAgeGroupCapacitiesAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      minCapacity
      maxCapacity
    }
    ageGroupedTotalCapacities @include(if: $withAgeGroupedTotalCapacities) {
      id
      ageGroups @include(if: $withAgeGroupedTotalCapacitiesAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      capacity
    }
    partialOccupancyAllowed
    partialOccupancyAllowedAgeGroups @include(if: $withPartialOccupancyAllowedAgeGroups) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
  }
}`

// language=GraphQL
export const SINGLE_CAPACITY_SETTINGS_QUERY = `query Query($id: ID!, $withAgeGroupCapacities: Boolean = false, $withAgeGroupCapacitiesAgeGroup: Boolean = false, $withAgeGroupedTotalCapacities: Boolean = false, $withAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withPartialOccupancyAllowedAgeGroups: Boolean = false) {
  capacitySettings: accommodationCapacitySettings(id: $id) {
    id
    totalCapacity
    rangesAllowed
    ageGroupCapacities @include(if: $withAgeGroupCapacities) {
      id
      ageGroup @include(if: $withAgeGroupCapacitiesAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      minCapacity
      maxCapacity
    }
    ageGroupedTotalCapacities @include(if: $withAgeGroupedTotalCapacities) {
      id
      ageGroups @include(if: $withAgeGroupedTotalCapacitiesAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      capacity
    }
    partialOccupancyAllowed
    partialOccupancyAllowedAgeGroups @include(if: $withPartialOccupancyAllowedAgeGroups) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
  }
}`

// language=GraphQL
export const CREATE_CAPACITY_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateAccommodationCapacitySettingsInput, $withAgeGroupCapacities: Boolean = false, $withAgeGroupCapacitiesAgeGroup: Boolean = false, $withAgeGroupedTotalCapacities: Boolean = false, $withAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withPartialOccupancyAllowedAgeGroups: Boolean = false) {
    capacitySettings: createAccommodationCapacitySettings(input: $input) {
      id
      totalCapacity
      rangesAllowed
      ageGroupCapacities @include(if: $withAgeGroupCapacities) {
        id
        ageGroup @include(if: $withAgeGroupCapacitiesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        minCapacity
        maxCapacity
      }
      ageGroupedTotalCapacities @include(if: $withAgeGroupedTotalCapacities) {
        id
        ageGroups @include(if: $withAgeGroupedTotalCapacitiesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        capacity
      }
      partialOccupancyAllowed
      partialOccupancyAllowedAgeGroups @include(if: $withPartialOccupancyAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
    }
  }`

// language=GraphQL
export const UPDATE_CAPACITY_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateAccommodationCapacitySettingsInput, $withAgeGroupCapacities: Boolean = false, $withAgeGroupCapacitiesAgeGroup: Boolean = false, $withAgeGroupedTotalCapacities: Boolean = false, $withAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withPartialOccupancyAllowedAgeGroups: Boolean = false) {
    capacitySettings: updateAccommodationCapacitySettings(input: $input) {
      id
      totalCapacity
      rangesAllowed
      ageGroupCapacities @include(if: $withAgeGroupCapacities) {
        id
        ageGroup @include(if: $withAgeGroupCapacitiesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        minCapacity
        maxCapacity
      }
      ageGroupedTotalCapacities @include(if: $withAgeGroupedTotalCapacities) {
        id
        ageGroups @include(if: $withAgeGroupedTotalCapacitiesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        capacity
      }
      partialOccupancyAllowed
      partialOccupancyAllowedAgeGroups @include(if: $withPartialOccupancyAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
    }
  }`

// language=GraphQL
export const DELETE_CAPACITY_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteAccommodationCapacitySettingsInput) {
    deleteAccommodationCapacitySettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CAPACITY_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteAccommodationCapacitySettingsInput) {
    forceDeleteAccommodationCapacitySettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION = `
  mutation Mutation($input: addAccommodationCapacitySettingsAgeGroupCapacitiesInput) {
    addAccommodationCapacitySettingsAgeGroupCapacities(input: $input) {
      id
      ageGroupCapacityIds
    }
  }`

// language=GraphQL
export const REMOVE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION = `
  mutation Mutation($input: removeAccommodationCapacitySettingsAgeGroupCapacitiesInput) {
    removeAccommodationCapacitySettingsAgeGroupCapacities(input: $input) {
      id
      ageGroupCapacityIds
    }
  }`

// language=GraphQL
export const CREATE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION = `
  mutation Mutation($input: createAccommodationCapacitySettingsAgeGroupCapacitiesInput) {
    createAccommodationCapacitySettingsAgeGroupCapacities(input: $input) {
      id
      ageGroupCapacityIds
    }
  }`

// language=GraphQL
export const DELETE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION = `
  mutation Mutation($input: deleteAccommodationCapacitySettingsAgeGroupCapacitiesInput) {
    deleteAccommodationCapacitySettingsAgeGroupCapacities(input: $input) {
      id
      ageGroupCapacityIds
    }
  }`

// language=GraphQL
export const UPDATE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_ORDER_MUTATION = `
  mutation Mutation($input: updateAccommodationCapacitySettingsAgeGroupCapacitiesOrderInput) {
    updateAccommodationCapacitySettingsAgeGroupCapacitiesOrder(input: $input) {
      id
      ageGroupCapacityIds
    }
  }`

// language=GraphQL
export const ADD_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION = `
  mutation Mutation($input: addAccommodationCapacitySettingsAgeGroupedTotalCapacitiesInput) {
    addAccommodationCapacitySettingsAgeGroupedTotalCapacities(input: $input) {
      id
      ageGroupedTotalCapacityIds
    }
  }`

// language=GraphQL
export const REMOVE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION = `
  mutation Mutation($input: removeAccommodationCapacitySettingsAgeGroupedTotalCapacitiesInput) {
    removeAccommodationCapacitySettingsAgeGroupedTotalCapacities(input: $input) {
      id
      ageGroupedTotalCapacityIds
    }
  }`

// language=GraphQL
export const CREATE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION = `
  mutation Mutation($input: createAccommodationCapacitySettingsAgeGroupedTotalCapacitiesInput) {
    createAccommodationCapacitySettingsAgeGroupedTotalCapacities(input: $input) {
      id
      ageGroupedTotalCapacityIds
    }
  }`

// language=GraphQL
export const DELETE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION = `
  mutation Mutation($input: deleteAccommodationCapacitySettingsAgeGroupedTotalCapacitiesInput) {
    deleteAccommodationCapacitySettingsAgeGroupedTotalCapacities(input: $input) {
      id
      ageGroupedTotalCapacityIds
    }
  }`

// language=GraphQL
export const UPDATE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_ORDER_MUTATION = `
  mutation Mutation($input: updateAccommodationCapacitySettingsAgeGroupedTotalCapacitiesOrderInput) {
    updateAccommodationCapacitySettingsAgeGroupedTotalCapacitiesOrder(input: $input) {
      id
      ageGroupedTotalCapacityIds
    }
  }`

// language=GraphQL
export const ADD_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: addAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsInput) {
    addAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups(input: $input) {
      id
      partialOccupancyAllowedAgeGroupIds
    }
  }`

// language=GraphQL
export const REMOVE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: removeAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsInput) {
    removeAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups(input: $input) {
      id
      partialOccupancyAllowedAgeGroupIds
    }
  }`

// language=GraphQL
export const CREATE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: createAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsInput) {
    createAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups(input: $input) {
      id
      partialOccupancyAllowedAgeGroupIds
    }
  }`

// language=GraphQL
export const DELETE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: deleteAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsInput) {
    deleteAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups(input: $input) {
      id
      partialOccupancyAllowedAgeGroupIds
    }
  }`

// language=GraphQL
export const UPDATE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_ORDER_MUTATION = `
  mutation Mutation($input: updateAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsOrderInput) {
    updateAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsOrder(input: $input) {
      id
      partialOccupancyAllowedAgeGroupIds
    }
  }`

// language=GraphQL
export const CAPACITY_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioFamilyPackages: Boolean = false, $withRatioAccommodations: Boolean = false) {
  groupedDependents: accommodationCapacitySettingsDependents(id: $id) {
    ratioFamilyPackages @include(if: $withRatioFamilyPackages) {
      id
      ratioServiceNo
      name
      label
      info
    }
    ratioAccommodations @include(if: $withRatioAccommodations) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
    }
  }
}`
